module.exports = __webpack_public_path__ + "img/cy.ce82666.svg";